import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { action, makeAutoObservable } from 'mobx';
import styles from './PopoverDialog.module.scss';

export const PopoverDialog = observer(() => {
    const { isVisible, customClass } = popoverDialogStore;

    return (
        <div className={`${styles.root} ${customClass} ${isVisible ? styles.show : ''}`}>
            {isVisible && <PopoverBody/>}
        </div>
    );
});

const PopoverBody = observer(() => {
    const { hidePopover, body } = popoverDialogStore;
    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            if (event.target && !(event.target as Element).closest(`.${styles.root}`)) {
                hidePopover();
            }
        };

        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                hidePopover();
            }
        };

        document.addEventListener('click', handleClick);
        document.addEventListener('keydown', handleEsc);

        return () => {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('keydown', handleEsc);
        };
    }, [hidePopover]);

    return (
        <div className={styles.body}>
            <div className={`${styles.close}`} onClick={() => {
                hidePopover()}}></div>
            {body}
        </div>
    );
});

class PopoverDialogStore {
    public isVisible: boolean = false;
    public body: JSX.Element | null = null;
    public customClass: string = '';

    constructor () {
        makeAutoObservable(this);
    }

    @action.bound
    public showPopover (body: JSX.Element, bodyClassName?: string) {
        this.isVisible = true;
        this.body = body;
        this.customClass = bodyClassName || '';
    }

    @action.bound
    public hidePopover = () => {
        this.isVisible = false;
        this.customClass = '';
    };
}

export const popoverDialogStore = new PopoverDialogStore();